import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import EditCalendarOutlinedIcon from '@mui/icons-material/EditCalendarOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    type: 'group',
    title: 'Menu Principal',
    children: [
        {
            id: 'default',
            title: 'Reservar Sala',
            type: 'item',
            url: '/agendamentos',
            icon: EditCalendarOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'meus-agendamentos',
            title: 'Meus Agendamentos',
            type: 'item',
            url: '/meus-agendamentos',
            icon: ListAltOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'timeline',
            title: 'Agenda do Dia',
            type: 'item',
            url: '/timeline',
            icon: EventNoteOutlinedIcon,
            breadcrumbs: false,
            color: 'success',
            variant: 'success',
            target: '_blank'
        }
    ]
};

export default dashboard;
